import { ChevronRightIcon } from 'lucide-react';

import type { TokenTotals } from '@/lib/api/generated/model';

import {
  Collapsible,
  CollapsiblePanel,
  CollapsibleTrigger,
} from '@/components/ui/collapsible';
import {
  DISCLOSURE_CHEVRON,
  DISCLOSURE_TRIGGER,
} from '@/shared/components/disclosure';
import { TokenComposition } from './TokenComposition';

/**
 * Where the period's tokens went, on request (spec 232 FR-003).
 *
 * The split by kind was a card of its own, a four-colour bar and four tiles of which
 * the two cache kinds were nearly all, an engineering detail most owners never act on.
 * The total now ends the meter's footer; the split waits behind this button, closed,
 * for the reader who wants it. The composition itself is unchanged (spec 076 US2).
 */
export function TokenDetails({ totals }: { totals: TokenTotals }) {
  if (totals.total_tokens === 0) return null;

  return (
    <Collapsible className="flex flex-col gap-3">
      <CollapsibleTrigger className={DISCLOSURE_TRIGGER}>
        <ChevronRightIcon aria-hidden="true" className={DISCLOSURE_CHEVRON} />
        Token details
      </CollapsibleTrigger>
      <CollapsiblePanel>
        <TokenComposition totals={totals} bare />
      </CollapsiblePanel>
    </Collapsible>
  );
}
